import { getInstance } from '../index';
import { setURLParams } from '../../utilities/application/urlHelper';
import { apiBaseUrl } from '../../utilities/api/apiHelper';

class Dashboard {
  constructor() {
    this.axios = getInstance();
  }

  async fetchLatestApplications() {
    return await this.axios.get(
      `${apiBaseUrl}/backendforfrontend/application/search`
    );
  }

  async fetchApplications(data) {
    const params = [];
    try {
      if (data.searchText) {
        params.push({ searchTerm: data.searchText });
      }
      if (data.stages) {
        params.push(...data.stages.map((stage) => ({ status: stage })));
      }
      if (data.page) {
        params.push({ page: data.page });
      }
      if (data.adviserId) {
        params.push({ adviserId: data.adviserId });
      }
    } catch {
      //
    }
    return await this.axios.get(
      `${apiBaseUrl}/backendforfrontend/application/search${setURLParams(
        params
      )}`
    );
  }

  async fetchPolicyHolders(data) {
    const params = [];
    try {
      if (data.searchText) {
        params.push({ searchTerm: data.searchText });
      }
      if (data.stages) {
        params.push(...data.stages.map((stage) => ({ status: stage })));
      }
      if (data.page) {
        params.push({ page: data.page });
      }
      if (data.adviserId) {
        params.push({ adviserId: data.adviserId });
      }
    } catch {
      //
    }
    return await this.axios.get(
      `${apiBaseUrl}/backendforfrontend/policy/search${setURLParams(params)}`
    );
  }
}

const dashboard = new Dashboard(getInstance());
export default dashboard;
